module.exports = __webpack_public_path__ + "img/xbit3.cafc15a1.png";